import { call, put, takeLatest } from "redux-saga/effects";
import {
  editQuizathonFailure,
  editQuizathonStart,
  editQuizathonSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpEditQuizathon } from "../../../services/quizathon";
import { successNotifier } from "../../../utils/helpers";

export function* editQuizathon({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpEditQuizathon, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editQuizathonSuccess());
    successNotifier("quizathon edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editQuizathonFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onEditQuizathon() {
  yield takeLatest(editQuizathonStart.type, editQuizathon);
}
